import * as React from "react";
const SvgMinus = (props) => /* @__PURE__ */ React.createElement("svg", { width: 14, height: 14, viewBox: "0 0 14 14", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("line", { x1: 12.578, y1: 7, x2: 0.999988, y2: 7, stroke: "currentColor", strokeWidth: 2, strokeLinecap: "round" }));
export default SvgMinus;
